import * as Api from '@ViewModels';
import { useMutation } from '@tanstack/react-query';
import { useUserSession } from '../../models/hooks/appStateHooks';

export const usePostExternalIntegrationOAuthClientMutation = ({
	onError,
	onSuccess,
	impersonationContext,
}: {
	onError?: (error: Api.IOperationResultNoValue) => void;
	onSuccess?: () => void;
	impersonationContext?: Api.IImpersonationContext;
} = {}) => {
	const userSession = useUserSession();

	return useMutation({
		mutationFn: ({
			integrationProvider,
			clientId,
			clientSecret,
			personalAccessToken,
		}: {
			integrationProvider: Api.IntegrationProvider;
			clientId: string;
			clientSecret: string;
			personalAccessToken?: string;
		}) => {
			return userSession.webServiceHelper.callAsync(
				Api.ImpersonationBroker.composeApiUrl({
					impersonationContext,
					urlPath: `integrations/${integrationProvider}/oAuthClient`,
				}),
				'POST',
				{
					clientId,
					clientSecret,
					...(personalAccessToken ? { personalAccessToken } : {}),
				}
			);
		},
		onError,
		onSuccess,
	});
};
